import { HttpMethod, HttpRepository } from "../../core/repository/http_repository";
import { Student, StudentInput } from "./student_model";

export class StudentHttpRepository extends HttpRepository {
  list = (page: number) => this._jsonRequest<Student[]>(HttpMethod.GET, `/students?page=${page}`);
  save = (input: StudentInput) => this._jsonRequest<{ id?: string; _id?: string }>(
    input._id ? HttpMethod.PUT : HttpMethod.POST, "/students", input,
  );
}
